import { z } from "zod";

/**
 * Per-bucket Outbox status-tab counts (PREC-3850). SQL COUNT() aggregates arrive
 * as strings from the API, so the schema coerces at the boundary — the tab
 * badges (and the client-side "All" sum) need real numbers.
 */
export const OutboxCountsSchema = z.object({
	scheduled: z.coerce.number(),
	inProgress: z.coerce.number(),
	ended: z.coerce.number(),
	paused: z.coerce.number(),
	error: z.coerce.number(),
});

export type OutboxCounts = z.infer<typeof OutboxCountsSchema>;

/** One Outbox campaign-filter option; `id` is the campaign uuid the filter sends. */
export const OutboxCampaignOptionSchema = z.object({
	id: z.string(),
	name: z.string(),
	listId: z.number(),
	listName: z.string(),
});

export const OutboxCampaignOptionsSchema = z.array(OutboxCampaignOptionSchema);

export type OutboxCampaignOption = z.infer<typeof OutboxCampaignOptionSchema>;
